import { mutationAdd, type AddHookResponse } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useExportCache } from './cache'
import { toResponseError, type ExportAddInput, type ExportAddSuccess } from '@terros/common'

export function useAddExport(): AddHookResponse<ExportAddInput, ExportAddSuccess> {
  const cache = useExportCache()
  const mutation = useTantalimMutation<ExportAddInput, ExportAddSuccess>({
    url: '/export/add',
  })

  async function add(input: ExportAddInput): Promise<ExportAddSuccess> {
    try {
      const result = await mutation.mutateAsync(input)
      cache.addItem(result.export)
      return result
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
